import React, { createContext, useCallback, useContext, useRef, useState } from 'react';
import { ToastKind } from './types';

type Notify = (message: string, kind?: ToastKind) => void;
const Ctx = createContext<Notify>(() => undefined);

export const useToast = () => useContext(Ctx);

export function ToastProvider({ children }: { children: React.ReactNode }) {
  const [item, setItem] = useState<{ id: number; message: string; kind: ToastKind } | null>(null);
  const timer = useRef<number | undefined>(undefined);
  const notify = useCallback<Notify>((message, kind = 'info') => {
    window.clearTimeout(timer.current);
    setItem({ id: Date.now(), message, kind });
    timer.current = window.setTimeout(() => setItem(null), 4200);
  }, []);
  return (
    <Ctx.Provider value={notify}>
      {children}
      <div className="toast-wrap" aria-live="polite">
        {item && (
          <div key={item.id} className={'toast ' + item.kind} role="status">
            {item.message}
          </div>
        )}
      </div>
    </Ctx.Provider>
  );
}
